import { z } from 'zod'

export const signInSchema = z.object({
  username: z
    .string({ required_error: 'Benutzername ist erforderlich' })
    .min(1, { message: 'Bitte gib deinen Benutzernamen ein' }),
  password: z
    .string({ required_error: 'Passwort ist erforderlich' })
    .min(6, { message: 'Das Passwort muss mindestens 6 Zeichen haben' }),

  rememberMe: z.boolean()
})

export type TSignInSchema = z.infer<typeof signInSchema>

export const forgotPasswordSchema = z.object({
  email: z
    .string({ required_error: 'E-Mail ist erforderlich' })
    .email({ message: 'Bitte gültige E-Mail-Adresse eingeben' }),
})
export type TForgotPasswordSchema = z.infer<typeof forgotPasswordSchema>

export const resetPasswordSchema = z
  .object({
    password: z
      .string()
      .min(8, { message: 'Mindestens 8 Zeichen' })
      .regex(/[A-Z]/, { message: 'Mindestens ein Großbuchstabe' })
      .regex(/[a-z]/, { message: 'Mindestens ein Kleinbuchstabe' })
      .regex(/[0-9]/, { message: 'Mindestens eine Zahl' })
      .regex(/[^A-Za-z0-9]/, { message: 'Mindestens ein Sonderzeichen' }),
    confirmPassword: z.string().min(1, { message: 'Bitte Passwort bestätigen' }),
  })
  .refine((d) => d.password === d.confirmPassword, {
    message: 'Passwörter stimmen nicht überein',
    path: ['confirmPassword'],
  })
export type TResetPasswordSchema = z.infer<typeof resetPasswordSchema>
